import { render, staticRenderFns } from "./UOttawaTask5Fr.vue?vue&type=template&id=3bd1dad8&scoped=true&"
import script from "./UOttawaTask5Fr.vue?vue&type=script&lang=ts&"
export * from "./UOttawaTask5Fr.vue?vue&type=script&lang=ts&"
import style0 from "./UOttawaTask5Fr.vue?vue&type=style&index=0&id=3bd1dad8&prod&scoped=true&lang=css&"
import style1 from "./UOttawaTask5Fr.vue?vue&type=style&index=1&id=3bd1dad8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd1dad8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VDataTable,VIcon,VRow,VTextField})
